import Characteristics from './Characteristics';

export default Characteristics;
